/* eslint-disable react/jsx-no-useless-fragment */
import { useAppSelector } from 'hooks';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { ServiceCode } from 'store/user/types/service';

interface IsServiceEnabledProps {
  serviceCode: ServiceCode
}

const IsServiceEnabled: React.FC<IsServiceEnabledProps> = ({
  serviceCode,
  children,
}) => {
  const user = useAppSelector((state) => state.user);
  if (user.isTest) {
    return <>{children}</>;
  }

  const service = user.services.find((_service) => _service.code === serviceCode);

  if (!service) {
    return <Navigate to="/" />;
  }
  if (service.isDebugMode) {
    return <Navigate to="/" />;
  }

  return (
    <>{children}</>
  );
};

export default IsServiceEnabled;
